module.exports = __webpack_public_path__ + "img/IMG_0374_L_WoodMatted_MockedUp.7c488ad6.jpg";